<div class="simple-gallery" attr.data-label="{{activePhotoLabel}}">

	<div class="simple-gallery--main" *ngIf="hasActivePhoto(); else loading">

		<div class="full-screen" (click)="INDRA_openSlideshow()">
			<app-svg svg="icons.svg#interface--fullscreen" aria-hidden="true" [alt]="'tripExtras.alt.openGallery' | ibeadmin | async"></app-svg>
		</div>
		<div class="arrows">
			<div class="prev" (click)="prev()">
				<app-svg svg="icons.svg#general--arrow--left" aria-hidden="true" [alt]="'tripExtras.alt.arrowLeft' | ibeadmin | async"></app-svg>
			</div>
			<div class="next" (click)="next()">
				<app-svg svg="icons.svg#general--arrow--right" aria-hidden="true" [alt]="'tripExtras.alt.arrowRight' | ibeadmin | async"></app-svg>
			</div>
		</div>

		<div class="simple-gallery--main-img">
			<ng-container *ngIf="activePhoto(); else errorImage">
				<img src="{{ activePhoto()?.src }}" alt="">
			</ng-container>

			<ng-template #errorImage>
				<app-svg svg="icons.svg#airport--delays" aria-hidden="true" [alt]="'tripExtras.text.imageNotFound' | ibeadmin | async"></app-svg>
				<div class="not-found">{{ 'tripExtras.text.imageNotFound' | ibeadmin | async }}</div>
			</ng-template>
		</div>

	</div>

	<ul #galleryList class="simple-gallery--list" *ngIf="hasActivePhoto()">

			<li *ngFor="let photo of photos;let index = index" class="simple-gallery--list-item" [ngClass]="{ 'active': index == activeIndex }" (click)="selectIndex(index)">
				<img src="{{ photo.src }}" alt="{{photo.label}}" (error)="errorCallback(index)" (load)="loadCallback($event, photo)" >
			</li>
	</ul>

	<ng-template #loading>
		<ng-container *ngIf="isStillLoading">
			<div class="simple-gallery--main-img">
				<app-loading-shadow aria-hidden="true" class="loading-offers"></app-loading-shadow>
			</div>

			<ul class="simple-gallery--list" >
				<li class=" simple-gallery--list-item" *ngFor="let photo of [0,1,2,3,4,5,6,7]">
					<app-loading-shadow aria-hidden="true" class="loading-offers"></app-loading-shadow>
				</li>
			</ul>
		</ng-container>
	</ng-template>

</div>
